<template>
  <div horizontal  label="Active filters:" label-for="activeFilters">
    <b-button-group id="activeFilters" size="sm">
      <span v-if="buttons.length > 0" class="activebar" >{{lang.infotext_1}}: </span>

        <b-button pill class="filterbuttons" v-for="btn in buttons" :pressed.sync="btn.state" type="light" variant="outline-primary" :key="btn.caption" @click="deleteFilter(btn.caption)">
           &nbsp;{{ btn.caption }} <span class="x-button">×</span>
        </b-button>
        
    </b-button-group>

    
  </div>
</template>

<script>


export default {
  name: 'FiltersComponent',
  props:{
    lang: Object
  },
  data () {
    return {
      
    }
  },
  computed: {
    buttons(){
      var buttonsList=[];
      var len = this.activeFilters.length;
      for (var i = 0; i < len; i++){

        buttonsList.push({caption: this.activeFilters[i], state: false})

      }

      return buttonsList

    },
    
    activeFilters(){
      
      if (this.$store.getters.sectionPrefix == "pm"){
        return this.$store.getters.pm_activeFilters
      }
      if (this.$store.getters.sectionPrefix == "lm"){
        return this.$store.getters.lm_activeFilters
      }
      if (this.$store.getters.sectionPrefix == "projm"){
        return this.$store.getters.projm_activeFilters
      }
      
    }
  },
  created () {

  },
  updated() {
    

  },
  watch: {

  },
  methods: {
    
    deleteFilter: function(caption){
      

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteActiveFilter", caption);

      const obj = {
        name: caption
      }
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteActiveAction", obj);

      let name = "DataTableFilteredOnApiComponent";
      if (this.$store.getters.sectionPrefix == "lm"){
        name = "DataTableFilteredOnApiLibComponent";
      }
      if (this.$store.getters.sectionPrefix == "projm"){
        name = "DataTableFilteredOnApiProjComponent";
      }
        
      

      const reloadObj = {
          status: true,
          name: name
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      
    }
  }
}
</script>


<style scoped>
  .activebar{
    margin-right: 20px;
    margin-top:3px;
  }
  .x-button{
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: rgba(128,128,128,1);
  }
  .filterbuttons{
    margin-right: 4px;
    margin-top:5px;
    color: #E87C1E;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/FiltersComponent.vue